// eslint-disable-next-line @typescript-eslint/no-unused-vars
import * as React from 'react';

const TITLE = 'Link';

export function Link() {
  return (
    <svg
      width="24"
      height="24"
      aria-label={TITLE}
      role="img"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{TITLE}</title>
      <path
        d="M3.78112 12C3.78112 10.5609 4.87554 9.39594 6.22747 9.39594L11.0343 9.39594V7.5L6.22747 7.5C3.88841 7.5 2 9.51015 2 12C2 14.4898 3.88841 16.5 6.22747 16.5L11.0343 16.5V14.6041L6.22747 14.6041C4.87554 14.6041 3.78112 13.4391 3.78112 12ZM17.7725 7.5L12.9657 7.5V9.39594L17.7725 9.39594C19.1245 9.39594 20.2189 10.5609 20.2189 12C20.2189 13.4391 19.1245 14.6041 17.7725 14.6041L12.9657 14.6041V16.5L17.7725 16.5C20.1116 16.5 22 14.4898 22 12C22 9.51015 20.1116 7.5 17.7725 7.5ZM6.91416 12C6.91416 12.5254 7.32189 12.9594 7.81545 12.9594L16.206 12.9594C16.6996 12.9594 17.1073 12.5254 17.1073 12C17.1073 11.4746 16.6996 11.0406 16.206 11.0406L7.81545 11.0406C7.32189 11.0406 6.91416 11.4746 6.91416 12Z"
        fill="currentColor"
      />
    </svg>
  );
}
